module.exports = __webpack_public_path__ + "static/coverage-b8d0876486213764c1ecf9edd769cdbd.png";